import useStore from "../../store";
import { useEffect, useState } from "react";

export default function Captcha({ onCheck }: { onCheck: () => void }) {
  const [checked, setChecked] = useState(false);
  const [ripple, setRipple] = useState(false);
  const { ChromeO } = useStore();

  const handleCheck = () => {
    if (checked) return;
    setRipple(true);
    setTimeout(() => setRipple(false), 600); // clear ripple after anim
    setTimeout(() => setChecked(true), 300); // delay check so ripple shows first
    setTimeout(() => onCheck(), 2000); // delay check so ripple shows first
  };

  useEffect(() => {
    setChecked(ChromeO);
  }, [ChromeO]);

  return (
    <div className="flex items-center justify-start bg-cover bg-center py-5 w-full font-helvetica">
      <div className="bg-[#f9f9f9] border-2 rounded-md text-[#4c4a4b] flex flex-row items-center justify-between pr-2 w-full">
        <div className="flex flex-row items-center justify-start">
          <div className="relative w-8 h-8 flex items-center justify-center my-4 ml-4 mr-2">
            <label className="relative w-full h-full flex items-center justify-center cursor-pointer overflow-visible">
              <input
                type="checkbox"
                disabled={checked}
                checked={checked}
                onChange={handleCheck}
                className="absolute opacity-0 w-0 h-0"
              />
              <span
                className={`absolute bg-[#fcfcfc] border-gray-500 transition-all
                ${
                  checked
                    ? "animate-spinbox"
                    : "w-8 h-8 rounded-[3px] border-[2px]"
                }`}
              >
                {/* Ripple */}
                {ripple && (
                  <span className="absolute w-full h-full rounded-full bg-[#029f56] animate-ripple pointer-events-none z-0"></span>
                )}

                {/* Tick */}
                <span
                  className={`absolute w-[2em] h-[3.5em] -mt-[3px] right-3 rotate-45 opacity-0 z-10 ${
                    checked ? "animate-checkfade" : ""
                  }`}
                >
                  <span className="absolute block h-[4px] bottom-0 left-0 bg-[#029f56] animate-bottomslide"></span>
                  <span className="absolute block w-[4px] bottom-0 right-0 bg-[#029f56] animate-rightslide"></span>
                </span>
              </span>
            </label>
          </div>

          <div className="text-[14px] text-gray-500 font-semibold mr-4 ml-1 text-center text-left tracking-normal">
            I'm not a robot
          </div>
        </div>

        <div className="flex flex-col items-center self-end ml-4 text-[#9d9ba7] mt-2 mb-[2px]">
          <img
            src="https://forum.nox.tv/core/index.php?media/9-recaptcha-png/"
            alt="reCAPTCHA"
            className="w-10 h-10"
          />
          <p className="text-[10px] font-bold">reCAPTCHA</p>
          <small className="text-[8px] text-gray-500">Privacy - Terms</small>
        </div>
      </div>
    </div>
  );
}
